"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var constants_1 = require("../../shared/constants");
var user_helper_1 = require("../user_helper");
var user_store_1 = require("../../../reverb-js-common/user_store");
var elog = require("@reverbdotcom/commons/dist/elog");
var GRID_IMAGE_KEY = '_links.grid_image.href';
var HORIZONTAL_IMAGE_KEY = '_links.mobile_hero_image.href';
var ComparisonShoppingPage = /** @class */ (function () {
    function ComparisonShoppingPage(cspJSON) {
        this.id = cspJSON.id;
        this.brand = cspJSON.brand;
        this._links = cspJSON._links;
        this.title = cspJSON.title;
        this.usedLowPrice = cspJSON.used_low_price || {};
        this.newLowPrice = cspJSON.new_low_price || {};
        this.usedListingsCount = cspJSON.used_total;
        this.newListingsCount = cspJSON.new_total;
        this.heroImage = cspJSON.hero_image;
        this.slug = cspJSON.slug;
    }
    ComparisonShoppingPage.prototype.gridImageHref = function () {
        return lodash_1.get(this, GRID_IMAGE_KEY);
    };
    ComparisonShoppingPage.prototype.horizontalImageHref = function () {
        return lodash_1.get(this, HORIZONTAL_IMAGE_KEY);
    };
    ComparisonShoppingPage.prototype.hasGridImage = function () {
        return !!this.gridImageHref();
    };
    ComparisonShoppingPage.prototype.hasHorizontalImage = function () {
        return !!this.horizontalImageHref();
    };
    ComparisonShoppingPage.prototype.webLink = function () {
        if (user_helper_1.cspShippingRegionSupported(user_store_1.default.getState().shippingRegionCode)) {
            return this._links.web.href;
        }
        return this.globalLink(this._links.web.href);
    };
    ComparisonShoppingPage.prototype.usedListingsLink = function () {
        if (user_helper_1.cspShippingRegionSupported(user_store_1.default.getState().shippingRegionCode)) {
            return this._links.web.used_listings.href;
        }
        return this.globalLink(this._links.web.used_listings.href);
    };
    ComparisonShoppingPage.prototype.newListingsLink = function () {
        if (user_helper_1.cspShippingRegionSupported(user_store_1.default.getState().shippingRegionCode)) {
            return this._links.web.new_listings.href;
        }
        return this.globalLink(this._links.web.new_listings.href);
    };
    ComparisonShoppingPage.prototype.globalLink = function (url) {
        var anchors = url.match(/#.+$/); // matches '#new' in 'url.com/something#new'
        if (anchors) {
            var urlWithoutAnchor = url.replace(anchors[0], '');
            return urlWithoutAnchor + "?ships_to=" + constants_1.default.EVERYWHERE_CODE + anchors[0];
        }
        return url + "?ships_to=" + constants_1.default.EVERYWHERE_CODE;
    };
    ComparisonShoppingPage.prototype.lowestPrice = function () {
        var prices = [];
        if (Object.keys(this.usedLowPrice).length > 0) {
            prices.push(this.usedLowPrice);
        }
        if (Object.keys(this.newLowPrice).length > 0) {
            prices.push(this.newLowPrice);
        }
        if (prices.length === 1) {
            return prices[0];
        }
        var lowestPrice = prices
            .filter(function (price) { return price; })
            .sort(function (p1, p2) { return p1.amount_cents - p2.amount_cents; })[0];
        return lowestPrice;
    };
    ComparisonShoppingPage.prototype.lowestPriceIsUsed = function () {
        if (!this.usedLowPrice.amount_cents) {
            return false;
        }
        return this.lowestPrice().amount_cents === this.usedLowPrice.amount_cents;
    };
    ComparisonShoppingPage.prototype.lowestPriceIsNew = function () {
        if (!this.newLowPrice.amount_cents) {
            return false;
        }
        return this.lowestPrice().amount_cents === this.newLowPrice.amount_cents;
    };
    ComparisonShoppingPage.prototype.lowestPriceForEvent = function () {
        if (this.lowestPriceIsUsed()) {
            return {
                lowest_price_for_used: new elog.events.Price({
                    amount: lodash_1.get(this.usedLowPrice, 'amount_cents'),
                    currency: lodash_1.get(this.usedLowPrice, 'currency'),
                }),
            };
        }
        if (this.lowestPriceIsNew()) {
            return {
                lowest_price_for_new: new elog.events.Price({
                    amount: lodash_1.get(this.newLowPrice, 'amount_cents'),
                    currency: lodash_1.get(this.newLowPrice, 'currency'),
                }),
            };
        }
        return {};
    };
    ComparisonShoppingPage.prototype.asEventWithLowestPrice = function () {
        return new elog.events.ComparisonShoppingPage((tslib_1.__assign({ id: String(this.id) }, this.lowestPriceForEvent())));
    };
    ComparisonShoppingPage.prototype.asEvent = function () {
        return new elog.events.ComparisonShoppingPage({
            id: String(this.id),
            lowest_price_for_new: new elog.events.Price({
                amount: lodash_1.get(this, 'newLowPrice.amount_cents'),
                currency: lodash_1.get(this, 'newLowPrice.currency'),
            }),
            lowest_price_for_used: new elog.events.Price({
                amount: lodash_1.get(this, 'usedLowPrice.amount_cents'),
                currency: lodash_1.get(this, 'usedLowPrice.currency'),
            }),
            used_listing_count: this.usedListingsCount,
            new_listing_count: this.newListingsCount,
        });
    };
    return ComparisonShoppingPage;
}());
exports.default = ComparisonShoppingPage;
//# sourceMappingURL=comparison_shopping_page.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/comparison_shopping_page.js
// module id = 3OZI
// module chunks = 20 21